import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { INVALID_TOKEN } from '@/constant';
import { Request } from '@/util/types';
import store from '@/store';

const config: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
};

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const inAnIframe = !(window === window.parent);
    const allowDirectOpen = process.env.VUE_APP_ALLOW_DIRECT_OPEN === 'true';

    if (!inAnIframe && !allowDirectOpen) {
      window.location.href=process.env.VUE_APP_GO_HOME_URL;
    }

    if (!config.headers?.Authorization) {
      config.headers = {
        ...config.headers,
        'Authorization':  `Bearer ${store.getters.token}`,
      };
    }
    return config;
  }, (err: AxiosError) => Promise.reject(err));

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error && error.response && error.response.status === INVALID_TOKEN) {
      store.commit('setRefreshToken', true);
    }
    return Promise.reject(error);
  });

export const request = ({
  url,
  method,
  data,
  params,
  headers
}: Request ) => {
  config.url = url;
  config.method = method;
  config.data = data;
  config.params = params,
  config.headers = {
    ...config.headers,
    ...headers
  };

  return axios(config);
};
